import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="widget-definition-form"
export default class extends Controller {
  static targets = ["rendererKind", "inputKind", "aiFields", "aiPrompt", "inputFields"]

  connect() {
    this.refresh()
  }

  refresh() {
    const rendererKind = this.rendererKindTarget?.value
    const inputKind = this.inputKindTarget?.value

    const isAi = rendererKind === "ai"
    this.toggleSection(this.aiFieldsTarget, isAi)

    if (this.hasAiPromptTarget) {
      this.aiPromptTarget.required = isAi
      this.aiPromptTarget.disabled = !isAi
    }

    const hasInput = inputKind && inputKind !== "none"
    this.toggleSection(this.inputFieldsTarget, hasInput)
  }

  toggleSection(el, shouldShow) {
    if (!el) return
    el.classList.toggle("hidden", !shouldShow)
  }
}
